import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { useComponentVariableMutable } from "src/shared/store/component-mutable/composables/useComponentVariableMutable";
import { computed, toRef } from "vue";
import { useComponentVariableStateStore } from "./component-variable-state";
import ComponentVariableDirtyFooter from "./footer/ComponentVariableDirtyFooter.vue";
import ComponentVariableErrorFooter from "./footer/ComponentVariableErrorFooter.vue";
const isChangedByUser = false;
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableFooter',
    props: {
        componentMutableKey: {},
        componentId: {},
        variableName: {},
        nodeType: {}
    },
    setup(__props) {
        const props = __props;
        const componentVariableStateStore = useComponentVariableStateStore();
        const { componentVariableMutable } = useComponentVariableMutable(toRef(props, "componentMutableKey"), toRef(props, "variableName"));
        const isDirty = computed(() => {
            var _a;
            return ((_a = componentVariableMutable.value) === null || _a === void 0 ? void 0 : _a.isDirty()) || false;
        });
        const error = computed(() => {
            return componentVariableStateStore.getError(props.componentMutableKey, props.variableName);
        });
        const reset = () => {
            if (componentVariableMutable.value) {
                componentVariableMutable.value.pull();
            }
            componentVariableStateStore.clearError(props.componentMutableKey, props.variableName);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (error.value)
                    ? (_openBlock(), _createBlock(ComponentVariableErrorFooter, {
                        key: 0,
                        error: error.value,
                        onReset: reset
                    }, null, 8 /* PROPS */, ["error"]))
                    : (isDirty.value)
                        ? (_openBlock(), _createBlock(ComponentVariableDirtyFooter, {
                            key: 1,
                            nodeType: _ctx.nodeType,
                            componentId: _ctx.componentId,
                            variableName: _ctx.variableName,
                            onReset: reset
                        }, null, 8 /* PROPS */, ["nodeType", "componentId", "variableName"]))
                        : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
